import React from 'react';
import { Form, reduxForm } from 'redux-form';

import Input from './Input';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => {
    return {
        form: {
            padding: theme.spacing(2), 
            width: '100%'
        }, 
        input: {
            marginTop: theme.spacing(1), 
            width: '100%'
        }, 
        button: {
            marginTop: theme.spacing(1)
        }
    };
}

const simpleForm = ({ classes, formElements, onSubmit, handleSubmit, className, title }) => {
    const formElementsArray = [];
    const classNames= [classes.form];
    const formTitle = title ? <Typography variant="h6" align="center">{title}</Typography> : null;

    if(className) {
        classNames.push(className);
    }

    for(let key in formElements) {
        formElementsArray.push({
            id: key, 
            config: formElements[key]
        });
    }

    return (
        <Form className={classNames.join(' ')} onSubmit={handleSubmit(onSubmit)}>
            {formTitle}
            {
                formElementsArray.map(formElement => <Input className={classes.input} key={formElement.id} {...formElement} />)
            }
            <div className="center"><Button className={classes.button} type="submit" variant="outlined" color="primary">SUBMIT</Button></div>
        </Form>
    );
}

export default reduxForm({enableReinitialize: true})(withStyles(styles)(simpleForm));